export const ApplyFormSummaryConst = [
  {
    id: "fast",
    title: "Быстрая заявка",
    fields: [
      { name: "Полное Имя", value: "Полное Имя", className: "fullname" },
      { name: "Номер телефона", value: "Номер телефона", className: "phone" },
      { name: "Электронная почта", value: "Электронная почта", className: "email" },
    ],
  },
  {
    id: "dop-info",
    title: "Дополнительная информация",
    fields: [
      { name: "Дата рождения", value: "Дата рождения", className: "birthDate" },
      { name: "Национальность", value: "Национальность", className: "nationality" },
      { name: "Адрес", value: "Адрес", className: "address" },
      { name: "Предыдущее образование", value: "Предыдущее образование", className: "education" },
    ],
  },
  {
    id: "program-details",
    title: "Детали программы",
    fields: [
      { name: "Специальность", value: "Специальность", className: "speciality" },
      { name: "Уровень степени", value: "Уровень степени", className: "levelEducation" },
      { name: "Форма обучения", value: "Форма обучения", className: "formStudy" },
      { name: "Комментарий", value: "Комментарий", className: "comment" },
    ],
  },
];

export const ApplyOnlineOptionsConst = {
  nationality: [
    { value: "", label: "-- Выберите национальность --", disabled: true },
    { value: "Украина", label: "Украина" },
    { value: "Польша", label: "Польша" },
    { value: "Германия", label: "Германия" },
    { value: "США", label: "США" },
    { value: "Франция", label: "Франция" },
    { value: "Италия", label: "Италия" },
    { value: "Испания", label: "Испания" },
  ],
  country: [
    { value: "", label: "-- Выберите страну --", disabled: true },
    { value: "Украина", label: "Украина" },
    { value: "Польша", label: "Польша" },
    { value: "Германия", label: "Германия" },
    { value: "США", label: "США" },
    { value: "Франция", label: "Франция" },
    { value: "Италия", label: "Италия" },
    { value: "Испания", label: "Испания" },
  ],
  speciality: [
    { value: "", label: "-- Выберите --", disabled: true },
    { value: "sec1", label: "sec1" },
    { value: "sec2", label: "sec2" },
    { value: "sec3", label: "sec3" },
  ],
  levelEducation: [
    { value: "", label: "-- Выберите --", disabled: true },
    { value: "sec1", label: "sec1" },
    { value: "sec2", label: "sec2" },
    { value: "sec3", label: "sec3" },
  ],
  formStudy: [
    { value: "", label: "-- Выберите форму обучения --", disabled: true },
    { value: "Очная", label: "Очная" },
    { value: "Заочная", label: "Заочная" },
    { value: "Дистанционная", label: "Дистанционная" },
  ],
};
